import ajax from '@/lib/ajax';
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { AppModule } from '@/store/Auth/AppModule'
import AppMedium from '@/models/Settings/AppMediums/AppMedium';
import CreateAppMediumRequest from '@/models/Settings/AppMediums/CreateAppMediumRequest';
import UpdateAppMediumRequest from '@/models/Settings/AppMediums/UpdateAppMediumRequest';
import PermissionUtils from '@/lib/permissionUtils';

export interface IAppMediumsState {
    loading: boolean;
    loadingDialog: boolean;
    appMediums: AppMedium[];
    totalAppMediumsPages: number;
    appMedium: AppMedium;
    newAppMediumId: string;
    pageSize: number;
}

@Module({ dynamic: true, store, name: 'AppMediumsModule', namespaced: true })
class AppMediumsStore extends VuexModule implements IAppMediumsState {

    public loading: boolean = true;
    public loadingDialog: boolean = false;
    public appMediums: AppMedium[] = [];
    public totalAppMediumsPages: number = 1;
    public appMedium: AppMedium = new AppMedium();
    public newAppMediumId: string = '';
    public pageSize: number = PermissionUtils.getPageSize();

    @Action
    async getAppMediums(pageNumber: number) {

        this.setLoading(true);

        await ajax.get(`/portal-backend/auth-api/internal/app-mediums?pageSize=${this.pageSize}&pageNumber=${pageNumber}`)
        .then(response => {
            this.context.commit("setAppMediums", response.data.appMediums);
            this.context.commit("setAppMediumsTotalPages", response.data.records.totalRecords);
            this.setLoading(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoading(false);
        });
    }

    @Action
    async createAppMedium(request: CreateAppMediumRequest) {

        this.setLoadingDialog(true);
        this.context.commit("setAppMediumFromCreate", null);

        await ajax.post(`/portal-backend/auth-api/internal/app-mediums`, request)
        .then(response => {
            this.context.commit("setAppMediumFromCreate", response.data.id);
            this.setLoadingDialog(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoadingDialog(false);
        });
    }

    @Action
    async editAppMedium(request: UpdateAppMediumRequest) {

        this.setLoadingDialog(true);

        await ajax.patch(`/portal-backend/auth-api/internal/app-mediums/${this.appMedium.id}`, request)
        .then(response => {
            this.context.commit("setAppMedium", response.data);
            this.setLoadingDialog(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoadingDialog(false);
        });
    }

    @Action
    async getAppMedium(id: string) {

        this.setLoading(true);

        await ajax.get(`/portal-backend/auth-api/internal/app-mediums/${id}`)
        .then(response => {
            this.context.commit("setAppMedium", response.data);
            this.setLoading(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoading(false);
        });
    }

    @Action
    cleanState() {
        this.context.commit("resetState");
    }

    @Mutation
    resetState() {
        this.loading = true;
        this.loadingDialog = false;
        this.appMediums = [];
        this.totalAppMediumsPages = 1;
        this.appMedium = new AppMedium();
        this.newAppMediumId = '';
    }

    @Mutation
    private async setLoading(loading: boolean) {
        this.loading = loading;
    }

    @Mutation
    private async setLoadingDialog(loading: boolean) {
        this.loadingDialog = loading;
    }

    @Mutation
    private async setAppMedium(response: AppMedium) {
        this.appMedium = response;
    }

    @Mutation
    private async setAppMediums(response: AppMedium[]) {
        if (response) {
            this.appMediums = response;
        }
    }

    @Mutation
    private async setAppMediumsTotalPages(total: number) {
        this.totalAppMediumsPages = Math.ceil(total/this.pageSize);
    }

    @Mutation
    private async setAppMediumFromCreate(appMediumId: string) {
        this.newAppMediumId = appMediumId;
    }

}

export const AppMediumsModule = getModule(AppMediumsStore);